import {i18n} from '@/locales';

export default {
  methods: {
    leadsSold(sold, max) {
      const left = max - sold;
      if (max === 1 && sold === 0) {
        return i18n.t('Exclusive')
      }

      switch (left) {
        case 0:
          return i18n.t('Sold Out');
        case 1:
          return i18n.t('Last One!');
        default:
          return (left === max) ? i18n.t('Quote First') : i18n.tc('{n} Sold', sold);
      }
    }
  }
}
